export default __webpack_public_path__ + "static/media/carbon-icon.84ebfb28.png";